/**
 * Transforma um valor monetário em number (float)
 * Aceita o padrão com 'R$' seguido de valores com separadores de milhar e decimais.
 * @param value string no formato 'R$ #.###,##'
 * @returns valor convertido para número (float)
 */
export const useCurrencyToNumber = (value?: string): number => {
  if (!value) return 0;

  const sanitizedValue = value
    .replace(/[R$\s]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');

  const numberValue = parseFloat(sanitizedValue);

  return isNaN(numberValue) ? 0 : numberValue;
};
